import * as React from "react";

import WSProgressBar from "./WSProgressBar";
import GettingStarted from "../Components/WorkspaceCompany/GettingStarted";
// import WorkspaceSetup from "./WorkspaceSetup";
import { Link, useParams } from "react-router-dom";

import { useEffect } from "react";

import commoncss from "../../myfin_v2/css/common.module.css"
import wsCreationcss from "../../myfin_v2/css/workspaceCreation.module.css"

const WorkSpaceLayout = () => {
  const { workspaceId } = useParams();

  return (
    <>
          <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
            <div >
              <WSProgressBar activePage = {1} id={workspaceId} />
            </div>
            <div >
              <GettingStarted />
            </div>
          </div>
    </>
  );
};

export default WorkSpaceLayout;
